import React from 'react';
import { Link as RouterLink, NavLink as RouterNavLink } from 'react-router-dom';
import { canonicalLink } from '../lib/canonicalLink';
const normalize=to=>typeof to==='string'?canonicalLink(to):to?.pathname?{...to,pathname:canonicalLink(to.pathname)}:to;
export const Link=React.forwardRef((props,ref)=><RouterLink {...props} to={normalize(props.to)} ref={ref}/>);
export const NavLink=React.forwardRef((props,ref)=><RouterNavLink {...props} to={normalize(props.to)} ref={ref}/>);
